module.exports = __webpack_public_path__ + "static/media/launch.af2bd50b.svg";